export default {
  WAITING: '0',
  ACCEPTED: '1',
  MODIFIED: '2',
  REVOKED: '3',
  ORDER_GENERATED: '21',
  ORDER_SENT: '22',
  ORDER_NOT_SENT: '23',
  ORDER_VALIDATED: '24',
  ORDER_REJECTED: '25',
  MADE: '26',
  INSTALLMENT_PAID: '27',
  INST_ORDER_GENERATED: '31',
  INST_PAYMENT_SENT: '32',
  INST_PAYMENT_NOT_SENT: '33',
  INST_PAYMENT_VALIDATED: '34',
  INST_PAYMENT_REJECTED: '35',
  INST_MADE: '36',
  CANCELED: '8',
  EXPIRED: '9',
  ACCEPTED_AND_PAYED: '10',
  ACCEPTED_AND_PAYED_INST: '11',
  MODIFIED_AND_PAYED: '13',
  MODIFIED_AND_PAYED_INST: '14',
  REJECTED: '15',
  RECEIVED: '16',
  CANCELED_CONFIRM: '17',
  CANCELED_ABORT: '18',
  INFORMATION: '20',

  NOT_CLOSED_FOLDER: 'Folder_30',
  CLOSED_FOLDER: 'Folder_31',
  FOLDER_CONTAINING_EXPIRED: 'Folder_32',
  FOLDER_CONTAINING_REFUSED: 'Folder_33',

  NOT_CLOSED_PAYMENTGROUP: 'PaymentGroup_30',
  CLOSED_PAYMENTGROUP: 'PaymentGroup_31',
  PAYMENTGROUP_CONTAINING_EXPIRED: 'PaymentGroup_32',
  PAYMENTGROUP_CONTAINING_REFUSED: 'PaymentGroup_33',

  PROVIDER_INITIALIZED: 'Provider_0',
  PROVIDER_OPEN: 'Provider_1',
  PROVIDER_VALIDATED: 'Provider_2',
  PROVIDER_NOT_VALIDATED: 'Provider_3',
  PROVIDER_THIRD_PARTY_SENT: 'Provider_10',
  PROVIDER_THIRD_PARTY_VALIDATED: 'Provider_11',
  PROVIDER_THIRD_PARTY_REJECTED: 'Provider_12',
  PROVIDER_TO_REFRESH: 'Provider_20',
  PROVIDER_CLOSED: 'Provider_31',

  SELLER_INITIALIZED: 'Seller_0',
  SELLER_NOT_CLOSED: 'Seller_1',
  SELLER_CLOSED: 'Seller_2',
  SELLER_REVOKED: 'Seller_3',

  DOC_INITIALIZED: 'Doc_0',
  DOC_REQUEST_SENT: 'Doc_1',
  DOC_REQUEST_RECEIVED: 'Doc_2',
  DOC_REQUEST_REJECTED: 'Doc_3',
  DOC_REQUEST_CANCELED: 'Doc_4',
  DOC_REQUEST_OUT_TIME: 'Doc_5',
  DOC_REQUEST_ACCEPTED: 'Doc_6',
  DOC_REQUEST_REFUSED: 'Doc_7',
  DOC_REQUEST_READ: 'Doc_8',
  DOC_SENT: 'Doc_10',
  DOC_RECEIVED: 'Doc_11',
  DOC_REJECTED: 'Doc_12',
  DOC_VALIDATED: 'Doc_13',
  DOC_REFUSED: 'Doc_14',
  DOC_EXPIRED: 'Doc_15',
  DOC_VALIDATED_MAN: 'Doc_16',
  DOC_READ: 'Doc_18',
  DOC_CANCELED: 'Doc_19',
  DOC_NEGOTIATION_SENT: 'Doc_20',
  DOC_NEGOTIATION_RECEIVED: 'Doc_21',
  DOC_NEGOTIATION_ACCEPTED: 'Doc_22',
  DOC_NEGOTIATION_REVOKED: 'Doc_23',
  DOC_THIRD_PARTY_SENT: 'Doc_30',
  DOC_THIRD_PARTY_RECEIVED: 'Doc_31',
  DOC_THIRD_PARTY_REJECTED: 'Doc_32',
  DOC_THIRD_PARTY_VALIDATED: 'Doc_33',
  DOC_THIRD_PARTY_REFUSED: 'Doc_34',
  DOC_CLOSING: 'Doc_40',
  DOC_CLOSED: 'Doc_41',
  DOC_PAID: 'Doc_99',

  DRAFT_NEED_COMPLETED: 'Draft_1',
  DRAFT_WAITING_VALIDATION: 'Draft_2',
  DRAFT_WAITING_UPPER_VALIDATION: 'Draft_3',
  DRAFT_READY_TO_SEND: 'Draft_4',

  INVOICE_CREATED: 'Invoice_0',
  INVOICE_PAYMENT_INITIALIZED: 'Invoice_1',
  INVOICE_TRANSFER_INITIALIZED: 'Invoice_2',
  INVOICE_PAYMENT_DONE: 'Invoice_3',
  INVOICE_PARTIAL_PAYMENT: 'Invoice_4',
  INVOICE_TOTAL_PAYMENT: 'Invoice_5',
  INVOICE_COMMISSION_PAYMENT_INITIALIZED: 'Invoice_6',
  INVOICE_VENDOR_PAYMENT_INITIALIZED: 'Invoice_7',
  INVOICE_COMMISSION_PAYMENT_CONFIRMED: 'Invoice_8',
  INVOICE_VENDOR_PAYMENT_CONFIRMED: 'Invoice_9',
  INVOICE_ERROR: 'Invoice_10',
  INVOICE_CB_ERROR: 'Invoice_11',

  TRANSACTION_RECEIVED: 'Transaction_0',
  TRANSACTION_NO_MATCH: 'Transaction_1',
  TRANSACTION_AMBIGUOUS: 'Transaction_2',
  TRANSACTION_LINKED: 'Transaction_3',
  TRANSACTION_ALLOCATED: 'Transaction_4',
  TRANSACTION_VENTILATION: 'Transaction_5',
  TRANSACTION_IGNORED: 'Transaction_6'
}



// WEBPACK FOOTER //
// ./src/helpers/status.js